

export function Filter({value, operator, name, title, onChange, values, noOperator=false, jsonValue=false}) {

    const operators = {
        $lte: "≤",
        $gte: "≥",
    }

    return <div className="flex flex-row border-4 gap-1 p-2 bg-white justify-evenly rounded-xl">
        <div className={value ? "font-bold" : ""}>{title}</div>
        {!noOperator && <div><select value={operator || "$lte"} onChange={(e) => {
            onChange({name, value, operator: e.target.value, noOperator, jsonValue});
        }}>
        { Object.keys(operators).map((opname) => {
            return <option key={"a" + opname} value={opname}>{operators[opname]}</option>
        })}</select></div>}
        <div className="md:flex-grow w-full"><select className="w-full" value={value} onChange={(e) => {
            console.log("Filter e.target.value", e.target.value);
            onChange({name, value: e.target.value, operator: operator || "$lte", noOperator, jsonValue});
        }}>
        {values.map((items) => {
            return <option key={"a" + JSON.stringify(items)} value={jsonValue ? JSON.stringify(items.value): items.value}>{items.title}</option>
        })}</select></div>
    </div>
}